module.exports = __webpack_public_path__ + "img/prop-sunflower-left.734cdddc.png";